import Vue from 'vue';
import Vuex from 'vuex';
import modalState from './modules/modal';
import userState from './modules/user';
Vue.use(Vuex)


export const store = new Vuex.Store({
	modules:{
		userState,
		modalState
	}
});



// WEBPACK FOOTER //
// ./src/store/store.js